import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    useNavigate,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
    Drawer,
    IconButton,
    Divider,
    Button,
} from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArchive } from '@fortawesome/pro-solid-svg-icons';
import { HomeRounded, FormatListBulletedOutlined } from '@material-ui/icons';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiTextBoxSearch } from '@mdi/js';
import { ManagerPage } from '../../../Enums';
import { UPDATE_MANAGER_APP_DATA } from '../../store/appData';
import './NavigationMenu.scss';

/**
 * @param {{
 *  extended: boolean,
 *  handleClose: () => void,
 *  managerPageSelected: number,
 * }} props
 */
function NavigationMenu(props) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'manager.common' });
    const dispatch = useDispatch();
    const { extended, handleClose, managerPageSelected = ManagerPage.None } = props;
    const [selectedPage, setSelectedPage] = useState(managerPageSelected);
    const navigate = useNavigate();

    const onClose = () => {
        if (handleClose && typeof handleClose === 'function') {
            handleClose();
        }
    };

    const options = [
        {
            label: t('manageBids'),
            value: ManagerPage.BiddingList,
            icon: <HomeRounded />,
            disabled: false,
            onClick: () => {
                setSelectedPage(ManagerPage.BiddingList);
                dispatch({ type: UPDATE_MANAGER_APP_DATA, payload: { pageName: t('manageBids') } });
                navigate('/Manager/');
            },
        },
        {
            label: t('audit'),
            value: ManagerPage.Audit,
            icon: (
                <MdiIcon
                    path={mdiTextBoxSearch}
                    size={1}
                />),
            disabled: false,
            onClick: () => {
                setSelectedPage(ManagerPage.Audit);
                dispatch({ type: UPDATE_MANAGER_APP_DATA, payload: { pageName: t('audit') } });
                navigate('/Manager/audit');
            },
        },
        {
            label: t('archive'),
            value: ManagerPage.Archives,
            icon: (
                <div className="general-icon-height">
                    <FontAwesomeIcon icon={faArchive} size="lg" className="archive-icon-positioning" />
                </div>
            ),
            disabled: false,
            onClick: () => {
                setSelectedPage(ManagerPage.Archives);
                dispatch({ type: UPDATE_MANAGER_APP_DATA, payload: { pageName: t('archive') } });
                navigate('/Manager/archive');
            },
        },
    ];

    return (
        <Drawer
            className="managerNavigationDrawer"
            variant="persistent"
            anchor="left"
            classes={{ paper: 'managerNavigationDrawerPaper' }}
            open={extended}
        >
            <div className="managerNavigationDrawerHeader">
                <IconButton
                    onClick={() => onClose()}
                >
                    <FormatListBulletedOutlined className="MuiSvgIcon-fontSizeMedium" fontSize="medium" />
                </IconButton>
                <div className="managerNavigationDrawerTitle">
                    <div className="managerNavigationDrawerMenuText">Menu</div>
                    <div className="managerNavigationDrawerAppNameText">{t('appName')}</div>
                </div>
            </div>

            <Divider />
            <div className="managerNavigationDrawerAppsContainer">
                {options.map((x) => (
                    <Button
                        className={`managerNavigationDrawerContent ${selectedPage === x.value ? 'selected' : ''}`}
                        onClick={x.onClick}
                        disabled={x.disabled}
                        key={`navigationOption_${x.label}`}
                    >
                        <span className="managerNavigationDrawerIcon">
                            {x.icon}
                        </span>
                        <span className={`text-md-medium ${selectedPage === x.value ? 'managerNavigationSelectedOptionLabel' : ''}`}>
                            {x.label}
                        </span>
                    </Button>
                ))}
            </div>
        </Drawer>
    );
}

export default NavigationMenu;
